import type {
	OfferingModel,
	SpineModel,
} from '@sosocio/creator-types/database';
import type { ArtworkSizeMetricUnits } from '@sosocio/creator-types/project';
import {
	inToPx,
	mmToPx,
} from './units';

export function getSpineModel(
	offeringModel: OfferingModel,
	pageCount: number,
	metricUnits: ArtworkSizeMetricUnits,
): SpineModel {
	if (!offeringModel.spine?.length) {
		throw new Error('Offering model does not include spine data');
	}

	const spineModelToUse = (
		offeringModel.spine
			.filter((spineModel) => pageCount >= spineModel.threshold)
			.sort((a, b) => a.threshold - b.threshold)
			.at(-1)
	);

	if (!spineModelToUse) {
		throw new Error(`No spine model matches the page count threshold of ${pageCount} for offering ${offeringModel.id}`);
	}

	const spineWidthInPixels = (
		metricUnits === 'in'
			? inToPx(
				spineModelToUse.width,
				offeringModel.configdpi,
				true,
			)
			: mmToPx(
				spineModelToUse.width,
				offeringModel.configdpi,
				true,
			)
	);

	return {
		...spineModelToUse,
		width: Math.max(
			80,
			spineWidthInPixels,
		),
	};
}
